<div class="login-container">
  <!-- Vue en cas d'erreur ou d'accès non autorisé -->
  <div *ngIf="hasError" class="card login-card error-card">
    <div class="logo-container">
      <img src="assets/logo_compteur.png?v=2" alt="Logo de l'application Teréga" class="app-logo">
      <h2>Teréga</h2>
      <p class="app-subtitle">Modif'Index - Relevé mensuel compteur</p>
    </div>

    <div class="error-banner">
      <div class="icon-circle" [class.warning]="!isAccessDenied">
        <!-- Icône Cadenas / Accès restreint -->
        <svg *ngIf="isAccessDenied" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
          <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
          <circle cx="12" cy="16" r="1"></circle>
        </svg>
        <!-- Icône Alerte générique -->
        <svg *ngIf="!isAccessDenied" xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
      </div>

      <h3 class="error-title">
        {{ isAccessDenied ? 'Accès non autorisé' : 'Échec de connexion' }}
      </h3>

      <p class="error-text">
        {{ isAccessDenied 
            ? 'Votre compte ne dispose pas des droits requis pour accéder à l\'application.' 
            : 'Une erreur s\'est produite lors de votre authentification.' }}
      </p>

      <div class="help-box">
        <span class="help-icon">ℹ️</span>
        <span>Pour demander une habilitation ou signaler une anomalie, veuillez contacter votre responsable ou le support informatique Teréga.</span>
      </div>
    </div>

    <div class="actions">
      <button class="btn btn-primary btn-block" (click)="retryLogin()">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
          <circle cx="12" cy="7" r="4"></circle>
        </svg>
        Se connecter avec un autre compte
      </button>

      <button type="button" class="btn-link" (click)="toggleDetails()">
        {{ showDetails ? 'Masquer les détails techniques' : 'Afficher les détails techniques' }}
      </button>

      <div class="technical-details" *ngIf="showDetails">
        <div class="detail-row">
          <span class="detail-label">Code d'erreur</span>
          <code>{{ errorCode }}</code>
        </div>
        <div class="detail-row">
          <span class="detail-label">Description</span>
          <code>{{ errorMessage }}</code>
        </div>
      </div>

      <button type="button" class="btn-dismiss" (click)="dismissError()">
        Retour à l'écran de connexion
      </button>
    </div>
  </div>

  <!-- Vue standard de connexion -->
  <div *ngIf="!hasError" class="card login-card">
    <div class="logo-container">
      <img src="assets/logo_compteur.png?v=2" alt="Logo de l'application Teréga" class="app-logo">
      <h2>Teréga</h2>
      <p class="app-subtitle">Modif'Index - Relevé mensuel compteur</p>
    </div>
    
    <div class="welcome-box">
      <p class="welcome-text">Outil de saisie et de correction des index des compteurs.</p>
      <p class="welcome-sub">Veuillez vous authentifier pour accéder à l'application.</p>
    </div>

    <div class="actions">
      <button class="btn btn-primary btn-block" (click)="login()">
        Se connecter
      </button>
    </div>
  </div>
</div>
